import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Phone } from "lucide-react";
import { formatUSD } from "@/lib/api";
import { ui } from "@/lib/ui";

export const Hero = ({ profile }) => (
  <section id="top" data-testid="hero-section" className="relative overflow-hidden border-b border-cyan-500/20">
    <img src="/hero-night.jpg" alt="Truck on a neon-lit highway at night" className="absolute inset-0 w-full h-full object-cover opacity-40" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#030712] via-[#030712]/85 to-[#030712]/30" />
    <div className="absolute inset-0 cyber-grid" />
    <div className="absolute inset-0 scanlines" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36 grid lg:grid-cols-[1.4fr_1fr] gap-12 items-end">
      <div className="rise-in">
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#00FF66] mb-6 blink-caret">dispatch online · 24/7</p>
        <h1 data-testid="company-name-heading" className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-wider leading-[1.05] text-white text-glow-cyan break-words">
          {profile.company_name}
        </h1>
        {profile.tagline && <p className="mt-6 text-base sm:text-lg text-slate-300 max-w-xl">{profile.tagline}</p>}
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/portal" data-testid="hero-request-tow-button" className={`${ui.btnPrimary} inline-flex items-center gap-2 px-6 py-3 text-sm`}>
            Request a tow <ArrowRight className="w-4 h-4" />
          </Link>
          {profile.phone && (
            <a href={`tel:${profile.phone}`} data-testid="hero-call-hotline-button" className={`${ui.btnMagenta} inline-flex items-center gap-2 px-6 py-3 text-sm`}>
              <Phone className="w-4 h-4" /> {profile.phone}
            </a>
          )}
        </div>
      </div>
      <div className="rise-in border bg-[#030712]/80 backdrop-blur-md p-6 glow-cyan hud-corner relative" style={{ animationDelay: "120ms" }} data-testid="hero-info-card">
        <p className={ui.label}>Headquarters</p>
        <p className="mt-2 flex gap-2 text-slate-100" data-testid="hero-hq-address"><MapPin className="w-4 h-4 mt-1 text-[#FF007F] shrink-0" />{profile.hq_address}</p>
        <div className="my-5 h-px bg-slate-800" />
        <p className={ui.label}>Pricing protocol</p>
        <p className="mt-2 font-mono text-2xl text-[#00FF66] text-glow-green" data-testid="hero-pricing-formula">
          {formatUSD(profile.base_charge)} <span className="text-slate-500 text-base">+</span> {formatUSD(profile.per_mile_rate)}<span className="text-sm text-slate-400">/mi</span>
        </p>
        <p className="mt-1 text-xs text-slate-500">Base service charge plus distance. See your exact estimate before you book.</p>
      </div>
    </div>
  </section>
);
